<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  currentVersion?: number
  newVersion?: number
}>()

const { t } = useI18n()
</script>

<template>
  <div class="d-flex align-center ga-4">
    <div>
      <div class="text-caption text-medium-emphasis">
        {{ t('component.libraryStepVersionChange.currentVersion') }}
      </div>
      <v-chip size="small" variant="tonal">v{{ props.currentVersion }}</v-chip>
    </div>
    <v-icon icon="arrow_forward" class="text-medium-emphasis mt-4" />
    <div>
      <div class="text-caption text-medium-emphasis">
        {{ t('component.libraryStepVersionChange.newVersion') }}
      </div>
      <v-chip size="small" color="primary" variant="flat">v{{ props.newVersion }}</v-chip>
    </div>
  </div>
</template>
